var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "activity-stage digital-citizenship"
  }, [!_vm.showCongratsScreen ? _c('section', {
    attrs: {
      "transition": "fade"
    }
  }, [!_vm.showCongratsScreen ? _c('h3', [_vm._v(_vm._s(_vm.currentRound.questionText))]) : _vm._e(), _c('h4', {
    attrs: {
      "transition": "fade"
    }
  }, [_vm._v(_vm._s(_vm.currentRound.instructions))])]) : _vm._e(), !_vm.showCongratsScreen ? _c('section', {
    staticClass: "sub-template-container",
    attrs: {
      "transition": "fade"
    }
  }, [_vm.currentRound.type === 'dragAndDrop' ? _c('drag-and-drop', {
    key: _vm.currentRound.roundIndex,
    attrs: {
      "transition": "fade",
      "round-index": _vm.currentRound.roundIndex,
      "steps": _vm.currentRound.steps,
      "image-path": _vm.currentRound.image,
      "answer-position": _vm.currentRound.answerPosition.toLowerCase(),
      "on-drop-label": _vm.handleStepEnd
    }
  }) : _vm._e(), _vm.currentRound.type === 'dropDownList' ? _c('drop-down-list', {
    key: _vm.currentRound.roundIndex,
    attrs: {
      "transition": "fade",
      "round-index": _vm.currentRound.roundIndex,
      "steps": _vm.currentRound.steps,
      "on-select-item": _vm.handleStepEnd
    }
  }) : _vm._e(), _vm.currentRound.type === 'singleSelect' ? _c('single-select', {
    key: _vm.currentRound.roundIndex,
    attrs: {
      "transition": "fade",
      "round-index": _vm.currentRound.roundIndex,
      "steps": _vm.currentRound.steps,
      "on-select": _vm.handleStepEnd
    }
  }) : _vm._e(), _vm.currentRound.type === 'multiSelect' ? _c('multi-select', {
    key: _vm.currentRound.roundIndex,
    attrs: {
      "transition": "fade",
      "round-index": _vm.currentRound.roundIndex,
      "steps": _vm.currentRound.steps,
      "on-check": _vm.handleStepEnd
    }
  }) : _vm._e(), _vm.currentRound.type === 'videoLesson' ? _c('video-player', {
    key: _vm.currentRound.roundIndex,
    attrs: {
      "transition": "fade",
      "round-index": _vm.currentRound.roundIndex,
      "url": _vm.currentRound.video,
      "on-video-end": _vm.handleStepEnd
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.showCongratsScreen ? _c('figure', {
    staticClass: "congrats",
    attrs: {
      "transition": "fade"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.assessmentCompletePath
    }
  })]) : _vm._e(), !_vm.showCongratsScreen && _vm.currentRound.type !== 'videoLesson' ? _c('footer', {
    staticClass: "progress-bar",
    attrs: {
      "transition": "fade"
    }
  }, [_c('progress-bar-container', {
    attrs: {
      "completed-units": _vm.lastRoundWasFinished ? _vm.activityData.rounds.length : _vm.progress.roundIndex,
      "total-units": _vm.activityData.rounds.length
    }
  })], 1) : _vm._e(), _c('static-intro-button', {
    attrs: {
      "enabled": _vm.canAdvance,
      "on-click": _vm.handleRoundEnd
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }